import type * as React from 'react';

import { PanelSet } from '@gitbook/spine-react';

import { isSiteOnlyCustomization, type SitesCustomizationPanelProps } from '../types';
import { ExternalLinksSettings } from './ExternalLinksSettings';
import { LanguageSettings } from './LanguageSettings';
import { PageActionsSettings } from './PageActionsSettings';
import { PageRatingsSettings } from './PageRatingsSettings';
import { PrimaryLinkSettings } from './PrimaryLinkSettings';
import { PrivacyPolicySettings } from './PrivacyPolicySettings';

/**
 * Tab "Configure" in the customization flow.
 */
export function TabConfigure(props: SitesCustomizationPanelProps): React.ReactElement {
    return (
        <PanelSet>
            <LanguageSettings {...props} />
            <PrimaryLinkSettings {...props} />
            <ExternalLinksSettings {...props} />
            {isSiteOnlyCustomization(props) ? (
                <>
                    <PageRatingsSettings {...props} />
                    <PageActionsSettings {...props} />
                </>
            ) : null}
            <PrivacyPolicySettings {...props} />
        </PanelSet>
    );
}
